export default class Accordion {
    constructor() {
        document.querySelectorAll('[data-ae-faqs-allow-multiple]').forEach((wrapper, wrapperIndex) => {
            this.initWrapper(wrapper, wrapperIndex);
        });
    }

    initWrapper(wrapper, wrapperIndex) {
        const items         = wrapper.querySelectorAll('.ae-faq-item');
        const allowMultiple = wrapper.dataset.aeFaqsAllowMultiple === 'true';
        const openFirst     = wrapper.dataset.aeFaqsOpenFirst === 'true';

        if (!items.length) return;

        items.forEach((item, index) => {
            const question = item.querySelector('.ae-faq-question');
            const answer   = item.querySelector('.ae-faq-answer');

            if (!question || !answer) return;

            const questionId = `ae-faq-question-${wrapperIndex}-${index}`;
            const answerId   = `ae-faq-answer-${wrapperIndex}-${index}`;

            question.setAttribute('id', questionId);
            question.setAttribute('role', 'button');
            question.setAttribute('aria-expanded', 'false');
            question.setAttribute('aria-controls', answerId);
            question.setAttribute('tabindex', '0');

            answer.setAttribute('id', answerId);
            answer.setAttribute('role', 'region');
            answer.setAttribute('aria-labelledby', questionId);

            question.addEventListener('click', () => this.toggle(item, items, allowMultiple));
            question.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.toggle(item, items, allowMultiple);
                }
            });
        });

        if (openFirst) this.open(items[0]);
    }

    toggle(activeItem, items, allowMultiple) {
        const isOpen = activeItem.classList.contains('is-open');

        if (!allowMultiple) {
            items.forEach((item) => this.close(item));
        }

        isOpen ? this.close(activeItem) : this.open(activeItem);
    }

    open(item) {
        item.classList.add('is-open');
        item.querySelector('.ae-faq-question')?.setAttribute('aria-expanded', 'true');
    }

    close(item) {
        item.classList.remove('is-open');
        item.querySelector('.ae-faq-question')?.setAttribute('aria-expanded', 'false');
    }
}
